export const getQualificationDetails = (
  qualificationId,
  qualificationDetails
) => {
  return qualificationDetails
    ? qualificationDetails.filter(
        qualification => qualification.qualificationId === qualificationId
      )
    : [];
};

export const getAddressDetails = (addressType, addressDetails = []) => {
  return (
    addressDetails.find(address => address.addressType === addressType) || {}
  );
};

export function getImageURLMapping(userDocuments) {
  return userDocuments && userDocuments.length
    ? userDocuments
        .filter(file => file.type !== "application/pdf")
        .map(file => ({ url: URL.createObjectURL(file), name: file.name }))
    : [];
}

export function getImageURL(imageURLMapping, image) {
  const imageURL = imageURLMapping.find(file => file.name === image.name);
  return imageURL ? imageURL.url : URL.createObjectURL(image);
}
